import { render, staticRenderFns } from "./CoursewareDialog.vue?vue&type=template&id=490dd37e&scoped=true&"
import script from "./CoursewareDialog.vue?vue&type=script&lang=js&"
export * from "./CoursewareDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490dd37e",
  null
  
)

export default component.exports